import { render, staticRenderFns } from "./EmptyApprovals.vue?vue&type=template&id=1871a930&scoped=true"
import script from "./EmptyApprovals.vue?vue&type=script&lang=js"
export * from "./EmptyApprovals.vue?vue&type=script&lang=js"
import style0 from "./EmptyApprovals.vue?vue&type=style&index=0&id=1871a930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871a930",
  null
  
)

export default component.exports